/*
 * The 16 German federal states, the granularity at which public holidays are configured.
 * Single source of truth for every Bundesland picker and label in the app.
 */
export const GERMAN_STATES = [
  { code: 'BW', name: 'Baden-Württemberg' },
  { code: 'BY', name: 'Bayern' },
  { code: 'BE', name: 'Berlin' },
  { code: 'BB', name: 'Brandenburg' },
  { code: 'HB', name: 'Bremen' },
  { code: 'HH', name: 'Hamburg' },
  { code: 'HE', name: 'Hessen' },
  { code: 'MV', name: 'Mecklenburg-Vorpommern' },
  { code: 'NI', name: 'Niedersachsen' },
  { code: 'NW', name: 'Nordrhein-Westfalen' },
  { code: 'RP', name: 'Rheinland-Pfalz' },
  { code: 'SL', name: 'Saarland' },
  { code: 'SN', name: 'Sachsen' },
  { code: 'ST', name: 'Sachsen-Anhalt' },
  { code: 'SH', name: 'Schleswig-Holstein' },
  { code: 'TH', name: 'Thüringen' },
] as const;

export type TGermanStateCode = typeof GERMAN_STATES[number]['code'];

const GERMAN_STATE_CODES: ReadonlySet<string> = new Set(GERMAN_STATES.map(({ code }) => code));

/** Addresses also carry Austrian (`AT-*`) and Swiss (`CH-*`) codes, which have no German rule. */
export const isGermanStateCode = (
  code: string | null | undefined,
): code is TGermanStateCode => !!code && GERMAN_STATE_CODES.has(code);

/** German display name for a state code, or null when the code is not a German one. */
export const germanStateName = (code: string | null | undefined): string | null =>
  GERMAN_STATES.find((state) => state.code === code)?.name ?? null;
